import { resolveLocale } from "@cronika/locales";
import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { localeStorage } from "@/shared/lib/locale-storage";
interface LocaleProviderProps {
  children: ReactNode;
}

export function LocaleProvider({ children }: LocaleProviderProps) {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const locale = resolveLocale({
      pathLocale: pathSegments[0],
      savedLocale: localeStorage.get(),
    });

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    localeStorage.set(locale);
  }, [location.pathname, i18n]);

  // Keep <html lang> in sync with the active locale. Date pickers and other
  // Intl-based components fall back to document.documentElement.lang, so without
  // this they'd use the OS/browser language instead of the app language.
  useEffect(() => {
    const applyLang = (lng: string) => {
      document.documentElement.lang = lng;
    };
    applyLang(i18n.language);
    i18n.on("languageChanged", applyLang);
    return () => {
      i18n.off("languageChanged", applyLang);
    };
  }, [i18n]);

  return <>{children}</>;
}
